import { AxiosInstance } from 'axios';
import { Source } from '../types';

const sortSources = (left: Source, right: Source): number => {
  if (left.backlog !== right.backlog) {
    return left.backlog ? 1 : -1;
  }

  return left.displayName.localeCompare(right.displayName);
};

export class SourcesApi {
  constructor(private readonly client: AxiosInstance) {}

  async getSources(): Promise<Source[]> {
    const response = await this.client.get<Source[]>('/api/sources');
    return [...response.data].sort(sortSources);
  }
}